import { IConfiguration, IConfigurationRegistry, IConfigurationService } from "../../domain/configuration";
import { ConfigurationService } from ".";
import { IConfigurationRepository } from "./IConfigurationRepository";

export class ConfigurationRegistry<TConfiguration extends IConfiguration = IConfiguration> implements IConfigurationRegistry<TConfiguration> {
  constructor(private readonly _repository: IConfigurationRepository<TConfiguration>) {
  }

  getConfigurationService(): IConfigurationService<TConfiguration> {
    return new ConfigurationService(this._repository);
  }
}
